// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HomeBaseBanner":"ti_a bih_b bih_bj","HomeBaseBanner__hint":"ti_b bih_vh","HomeBaseBanner__link":"ti_c"};